import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import { LOGIN_URL, SITE_NAME } from "@/config";
import SessionService from "@/services/SessionService";
import ElegirAgricultor from "@/views/ElegirAgricultor";
import AdministrarConceptos from "@/views/AdministrarConceptos";
import CrearEstablecimiento from "@/views/CrearEstablecimiento";
import ConfiguracionEstablecimientos from "@/views/ConfiguracionEstablecimientos";
import AgroHome from "@/views/agro/AgroHome.vue";
import GanaderiaHome from "@/views/ganaderia/GanaderiaHome.vue";
import FaltaInventarioInicial from "@/views/ganaderia/FaltaInventarioInicial.vue";
import NotFound from "@/views/NotFound";
import PrivacyPolicy from "@/views/PrivacyPolicy";
const Fichas = () =>
  import(/* webpackChunkName: 'view' */ "@/views/agro/configuraciones/Fichas");
const FichaABM = () =>
  import(
    /* webpackChunkName: 'view' */ "@/views/agro/configuraciones/FichaABM"
  );
const Maquinas = () =>
  import(
    /* webpackChunkName: 'view' */ "@/views/agro/configuraciones/Maquinas"
  );
const MaquinaABM = () =>
  import(
    /* webpackChunkName: 'view' */ "@/views/agro/configuraciones/MaquinaABM"
  );
const Personal = () =>
  import(
    /* webpackChunkName: 'view' */ "@/views/agro/configuraciones/Personal"
  );
const PersonalABM = () =>
  import(
    /* webpackChunkName: 'view' */ "@/views/agro/configuraciones/PersonalABM"
  );
const Productos = () =>
  import(
    /* webpackChunkName: 'view' */ "@/views/agro/configuraciones/Productos"
  );
const ProductoABM = () =>
  import(
    /* webpackChunkName: 'view' */ "@/views/agro/configuraciones/ProductoABM"
  );
const ProductosImportar = () =>
  import(
    /* webpackChunkName: 'view' */ "@/views/agro/configuraciones/ProductosImportar"
  );
const ElegirFicha = () =>
  import(/* webpackChunkName: 'view' */ "@/views/agro/ElegirFicha");
const Actividad = () =>
  import(/* webpackChunkName: 'view' */ "@/views/agro/actividades/Actividad");
const ActividadABM = () =>
  import(
    /* webpackChunkName: 'view' */ "@/views/agro/actividades/ActividadABM"
  );
const ActividadDetalle = () =>
  import(
    /* webpackChunkName: 'view' */ "@/views/agro/actividades/ActividadDetalle"
  );
const RendimientoCosecha = () =>
  import(
    /* webpackChunkName: 'view' */ "@/views/agro/actividades/RendimientoCosecha"
  );
const RendimientoCosechaABM = () =>
  import(
    /* webpackChunkName: 'view' */ "@/views/agro/actividades/RendimientoCosechaABM"
  );
const Precipitacion = () =>
  import(
    /* webpackChunkName: 'view' */ "@/views/agro/actividades/Precipitacion"
  );
const PrecipitacionABM = () =>
  import(
    /* webpackChunkName: 'view' */ "@/views/agro/actividades/PrecipitacionABM"
  );
const Alquiler = () =>
  import(/* webpackChunkName: 'view' */ "@/views/agro/actividades/Alquiler");
const AlquilerABM = () =>
  import(/* webpackChunkName: 'view' */ "@/views/agro/actividades/AlquilerABM");
const Resumen = () =>
  import(/* webpackChunkName: 'view' */ "@/views/agro/resumen/Resumen");
const ResumenCosto = () =>
  import(/* webpackChunkName: 'resumen' */ "@/views/agro/resumen/ResumenCosto");
const ResumenGanaderia = () =>
  import(
    /* webpackChunkName: 'view' */ "@/views/ganaderia/resumen/ResumenGanaderia"
  );
const ResumenMovimientos = () =>
  import(
    /* webpackChunkName: 'resumen' */ "@/views/ganaderia/resumen/ResumenMovimientos"
  );
const ResumenFinal = () =>
  import(
    /* webpackChunkName: 'resumen' */ "@/views/ganaderia/resumen/ResumenFinal"
  );
const ResumenGastosKg = () =>
  import(
    /* webpackChunkName: 'resumen' */ "@/views/ganaderia/resumen/ResumenGastosKg"
  );
const ResumenRendimientoFicha = () =>
  import(
    /* webpackChunkName: 'resumen' */ "@/views/agro/resumen/ResumenRendimientoFicha"
  );
const ResumenRendimientoVariedad = () =>
  import(
    /* webpackChunkName: 'resumen' */ "@/views/agro/resumen/ResumenRendimientoVariedad"
  );
const ResumenEstadisticas = () =>
  import(
    /* webpackChunkName: 'resumen' */ "@/views/agro/resumen/ResumenEstadisticas"
  );
const Estadisticas = () =>
  import(
    /* webpackChunkName: 'view' */ "@/views/agro/estadisticas/Estadisticas"
  );
const EstadisticasTipoTrabajo = () =>
  import(
    /* webpackChunkName: 'estadisticas' */ "@/views/agro/estadisticas/EstadisticasTipoTrabajo"
  );
const EstadisticasRubro = () =>
  import(
    /* webpackChunkName: 'estadisticas' */ "@/views/agro/estadisticas/EstadisticasRubro"
  );
const MovimientoFinanciero = () =>
  import(
    /* webpackChunkName: 'view' */ "@/views/ganaderia/actividades/MovimientoFinanciero"
  );
const MovimientoABM = () =>
  import(
    /* webpackChunkName: 'view' */ "@/views/ganaderia/actividades/MovimientoABM"
  );
const MovimientoDetalle = () =>
  import(
    /* webpackChunkName: 'view' */ "@/views/ganaderia/actividades/MovimientoDetalle"
  );
const ConfiguracionLotes = () =>
  import(
    /* webpackChunkName: 'view' */ "@/views/ganaderia/configuraciones/ConfiguracionLotes"
  );
const Inventarios = () =>
  import(
    /* webpackChunkName: 'view' */ "@/views/ganaderia/configuraciones/Inventarios"
  );
const InventarioInicial = () =>
  import(
    /* webpackChunkName: 'view' */ "@/views/ganaderia/configuraciones/InventarioInicial"
  );
const InventarioIntermedio = () =>
  import(
    /* webpackChunkName: 'view' */ "@/views/ganaderia/configuraciones/InventarioIntermedio"
  );
const InventarioResultado = () =>
  import(
    /* webpackChunkName: 'view' */ "@/views/ganaderia/configuraciones/InventarioResultado"
  );
const InventarioActual = () =>
  import(
    /* webpackChunkName: 'view' */ "@/views/ganaderia/configuraciones/InventarioActual"
  );
const InventarioFinal = () =>
  import(
    /* webpackChunkName: 'view' */ "@/views/ganaderia/configuraciones/InventarioFinal"
  );
const MovimientoAnimalBase = () =>
  import(
    /* webpackChunkName: 'view' */ "@/views/ganaderia/actividades/MovimientoAnimalBase"
  );
const MovimientoAnimal = () =>
  import(
    /* webpackChunkName: 'view' */ "@/views/ganaderia/actividades/MovimientoAnimal"
  );
const MovimientoAnimalResumen = () =>
  import(
    /* webpackChunkName: 'view' */ "@/views/ganaderia/actividades/MovimientoAnimalResumen"
  );
const Prenez = () =>
  import(/* webpackChunkName: 'view' */ "@/views/ganaderia/actividades/Prenez");

const FinalizarTemporada = () =>
  import(
    /* webpackChunkName: 'view' */ "@/views/ganaderia/configuraciones/FinalizarTemporada"
  );
const EstadisticasGanaderia = () =>
  import(
    /* webpackChunkName: 'view' */ "@/views/ganaderia/estadisticas/Estadisticas"
  );
const FaltaSuperficie = () =>
  import(/* webpackChunkName: 'view' */ "@/views/ganaderia/FaltaSuperficie");
const FaltaFichaGanadera = () =>
  import(
    /* webpackChunkName: 'view' */ "@/views/ganaderia/configuraciones/FaltaFichaGanadera"
  );

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      meta: { requiresCategoriaCheck: true },
    },
    {
      path: "/elegir-agricultor",
      name: "ElegirAgricultor",
      component: ElegirAgricultor,
    },
    {
      path: "/maquinas",
      name: "Maquinas",
      component: Maquinas,
      meta: { requiresEstablecimiento: true },
    },
    {
      path: "/maquinas/agregar",
      name: "AgregarMaquina",
      component: MaquinaABM,
      meta: { requiresEstablecimiento: true },
    },
    {
      path: "/maquinas/:id/editar",
      name: "EditarMaquina",
      component: MaquinaABM,
      props: true,
      meta: { requiresEstablecimiento: true },
    },
    {
      path: "/personal",
      name: "Personal",
      component: Personal,
      meta: { requiresEstablecimiento: true },
    },
    {
      path: "/personal/agregar",
      name: "AgregarPersonal",
      component: PersonalABM,
      meta: { requiresEstablecimiento: true },
    },
    {
      path: "/personal/:id/editar",
      name: "EditarPersonal",
      component: PersonalABM,
      props: true,
      meta: { requiresEstablecimiento: true },
    },
    {
      path: "/crear-establecimiento",
      name: "CrearEstablecimiento",
      component: CrearEstablecimiento,
      props: true,
    },
    {
      path: "/admin",
      name: "Administracion",
      component: AdministrarConceptos,
      meta: { requiresAdmin: true },
    },
    {
      path: "/configurar-establecimientos",
      name: "ConfiguracionEstablecimientos",
      component: ConfiguracionEstablecimientos,
      props: true,
      meta: { requiresEstablecimiento: true },
    },
    {
      path: "/agro",
      name: "AgroHome",
      component: AgroHome,
      meta: { requiresEstablecimiento: true, requiresHasAgro: true },
    },
    {
      path: "/agro/elegir-ficha",
      name: "ElegirFicha",
      component: ElegirFicha,
      meta: { requiresEstablecimiento: true, requiresHasAgro: true },
    },
    {
      path: "/agro/fichas",
      name: "Fichas",
      component: Fichas,
      meta: { requiresEstablecimiento: true, requiresHasAgro: true },
    },
    {
      path: "/agro/fichas/agregar",
      name: "AgregarFicha",
      component: FichaABM,
      meta: { requiresEstablecimiento: true, requiresHasAgro: true },
    },
    {
      path: "/agro/fichas/:id/editar",
      name: "EditarFicha",
      component: FichaABM,
      props: true,
      meta: { requiresEstablecimiento: true, requiresHasAgro: true },
    },
    {
      path: "/agro/productos",
      name: "Productos",
      component: Productos,
      meta: { requiresEstablecimiento: true, requiresHasAgro: true },
    },
    {
      path: "/agro/productos-senave-importar",
      name: "ProductosSenave",
      component: ProductosImportar,
    },
    {
      path: "/agro/productos/agregar",
      name: "AgregarProducto",
      component: ProductoABM,
      meta: { requiresEstablecimiento: true, requiresHasAgro: true },
    },
    {
      path: "/agro/productos/agregar-importar/:importId",
      name: "AgregarImportarProducto",
      component: ProductoABM,
      props: true,
      meta: { requiresEstablecimiento: true, requiresHasAgro: true },
    },
    {
      path: "/agro/productos/:id/editar",
      name: "EditarProducto",
      component: ProductoABM,
      props: true,
      meta: { requiresEstablecimiento: true, requiresHasAgro: true },
    },
    {
      path: "/agro/actividades/rendimiento-cosecha",
      name: "RendimientoCosecha",
      component: RendimientoCosecha,
      meta: {
        requiresFicha: true,
        requiresEstablecimiento: true,
        requiresHasAgro: true,
      },
    },
    {
      path: "/agro/actividades/rendimiento-cosecha/agregar",
      name: "AgregarRendimientoCosecha",
      component: RendimientoCosechaABM,
      meta: {
        requiresFicha: true,
        requiresEstablecimiento: true,
        requiresHasAgro: true,
      },
    },
    {
      path: "/agro/actividades/rendimiento-cosecha/:id/editar",
      name: "EditarRendimientoCosecha",
      component: RendimientoCosechaABM,
      props: true,
      meta: {
        requiresFicha: true,
        requiresEstablecimiento: true,
        requiresHasAgro: true,
      },
    },
    {
      path: "/agro/actividades/precipitacion",
      name: "Precipitacion",
      component: Precipitacion,
      meta: {
        requiresFicha: true,
        requiresEstablecimiento: true,
        requiresHasAgro: true,
      },
    },
    {
      path: "/agro/actividades/precipitacion/agregar",
      name: "AgregarPrecipitacion",
      component: PrecipitacionABM,
      meta: {
        requiresFicha: true,
        requiresEstablecimiento: true,
        requiresHasAgro: true,
      },
    },
    {
      path: "/agro/actividades/precipitacion/:id/editar",
      name: "EditarPrecipitacion",
      component: PrecipitacionABM,
      props: true,
      meta: {
        requiresFicha: true,
        requiresEstablecimiento: true,
        requiresHasAgro: true,
      },
    },
    {
      path: "/agro/actividades/alquiler",
      name: "Alquiler",
      component: Alquiler,
      meta: {
        requiresFicha: true,
        requiresEstablecimiento: true,
        requiresHasAgro: true,
      },
    },
    {
      path: "/agro/actividades/alquiler/agregar",
      name: "AgregarAlquiler",
      component: AlquilerABM,
      meta: {
        requiresFicha: true,
        requiresEstablecimiento: true,
        requiresHasAgro: true,
      },
    },
    {
      path: "/agro/actividades/alquiler/editar",
      name: "EditarAlquiler",
      component: AlquilerABM,
      meta: {
        requiresFicha: true,
        requiresEstablecimiento: true,
        requiresHasAgro: true,
      },
    },
    {
      path: "/agro/actividades/:rubroSlug",
      name: "Actividad",
      component: Actividad,
      props: true,
      meta: {
        requiresFicha: true,
        requiresEstablecimiento: true,
        requiresHasAgro: true,
      },
    },
    {
      path: "/agro/actividades/:rubroSlug/agregar",
      name: "AgregarActividad",
      component: ActividadABM,
      props: true,
      meta: {
        requiresFicha: true,
        requiresEstablecimiento: true,
        requiresHasAgro: true,
      },
    },
    {
      path: "/agro/actividades/:rubroSlug/:id/editar",
      name: "EditarActividad",
      component: ActividadABM,
      props: true,
      meta: {
        requiresFicha: true,
        requiresEstablecimiento: true,
        requiresHasAgro: true,
      },
    },
    {
      path: "/agro/actividades/:rubroSlug/:id/detalle",
      name: "DetalleActividad",
      component: ActividadDetalle,
      props: true,
      meta: {
        requiresFicha: true,
        requiresEstablecimiento: true,
        requiresHasAgro: true,
      },
    },
    {
      path: "/agro/resumen",
      redirect: { name: "ResumenCosto" },
      name: "Resumen",
      component: Resumen,
      meta: { requiresEstablecimiento: true, requiresHasAgro: true },
      children: [
        {
          path: "costo",
          name: "ResumenCosto",
          component: ResumenCosto,
        },
        {
          path: "rendimiento-ficha",
          name: "ResumenRendimientoFicha",
          component: ResumenRendimientoFicha,
        },
        {
          path: "rendimiento-variedad",
          name: "ResumenRendimientoVariedad",
          component: ResumenRendimientoVariedad,
        },
        {
          path: "estadisticas",
          name: "ResumenEstadisticas",
          component: ResumenEstadisticas,
        },
      ],
    },
    {
      path: "/agro/estadisticas",
      redirect: { name: "EstadisticasTipoTrabajo" },
      name: "Estadisticas",
      component: Estadisticas,
      meta: { requiresAdmin: true },
      children: [
        {
          path: "tipo-trabajo",
          name: "EstadisticasTipoTrabajo",
          component: EstadisticasTipoTrabajo,
        },
        {
          path: "rubro",
          name: "EstadisticasRubro",
          component: EstadisticasRubro,
        },
      ],
    },
    {
      path: "/ganaderia/falta-superficie",
      name: "FaltaSuperficie",
      component: FaltaSuperficie,
      meta: { requiresEstablecimiento: true, requiresHasGanaderia: true },
    },
    {
      path: "/ganaderia",
      name: "GanaderiaHome",
      component: GanaderiaHome,
      meta: { requiresEstablecimiento: true, requiresHasGanaderia: true },
    },
    {
      path: "/ganaderia/cargar-inventario",
      name: "FaltaInventario",
      component: FaltaInventarioInicial,
      meta: { requiresEstablecimiento: true, requiresHasGanaderia: true },
    },
    {
      path: "/ganaderia/agregar-ficha-ganadera",
      name: "FaltaFichaGanadera",
      component: FaltaFichaGanadera,
      meta: { requiresEstablecimiento: true, requiresHasGanaderia: true },
    },
    {
      path: "/ganaderia/movimientos/:conceptoSlug/agregar",
      name: "AgregarMovimiento",
      component: MovimientoABM,
      props: true,
      meta: { requiresEstablecimiento: true, requiresHasGanaderia: true },
    },
    {
      path: "/ganaderia/movimientos/:conceptoSlug/:id/editar",
      name: "EditarMovimiento",
      component: MovimientoABM,
      props: true,
      meta: { requiresEstablecimiento: true, requiresHasGanaderia: true },
    },
    {
      path: "/ganaderia/movimientos/:conceptoSlug/:id/detalle",
      name: "DetalleMovimiento",
      component: MovimientoDetalle,
      props: true,
      meta: { requiresEstablecimiento: true, requiresHasGanaderia: true },
    },
    {
      path: "/ganaderia/movimientos/:conceptoSlug/:idSubconcepto?/:fechaInicio?/:fechaFin?",
      name: "Movimiento",
      component: MovimientoFinanciero,
      props: true,
      meta: { requiresEstablecimiento: true, requiresHasGanaderia: true },
    },
    {
      path: "/ganaderia/prenez",
      name: "Prenez",
      component: Prenez,
      meta: {
        requiresEstablecimiento: true,
        requiresHasGanaderia: true,
        requiresHasInventarioInicial: true,
      },
    },
    {
      path: "/ganaderia/configuracion-lotes",
      name: "ConfiguracionLotes",
      component: ConfiguracionLotes,
      props: true,
      meta: { requiresEstablecimiento: true, requiresHasGanaderia: true },
    },
    {
      path: "/ganaderia/resumen",
      redirect: { name: "ResumenMovimientos" },
      name: "ResumenGanaderia",
      component: ResumenGanaderia,
      meta: {
        requiresEstablecimiento: true,
        requiresHasGanaderia: true,
        requiresSuperficie: true,
      },
      children: [
        {
          path: "movimientos",
          name: "ResumenMovimientos",
          component: ResumenMovimientos,
        },
        {
          path: "final",
          name: "ResumenFinal",
          component: ResumenFinal,
        },
        {
          path: "gastos",
          name: "ResumenGastosKg",
          component: ResumenGastosKg,
        },
      ],
    },
    {
      path: "/ganaderia/inventario",
      redirect: { name: "InventarioInicial" },
      name: "InventarioAnimal",
      component: Inventarios,
      meta: { requiresEstablecimiento: true, requiresHasGanaderia: true },
      children: [
        {
          path: "inicial",
          name: "InventarioInicial",
          component: InventarioInicial,
        },
        {
          path: "intermedio",
          name: "InventarioIntermedio",
          component: InventarioIntermedio,
        },
        {
          path: "resultado",
          name: "InventarioResultado",
          component: InventarioResultado,
        },
        {
          path: "actualizado",
          name: "InventarioActualizado",
          component: InventarioActual,
        },
        {
          path: "final",
          name: "InventarioFinal",
          component: InventarioFinal,
        },
        {
          path: "finalizar-temporada",
          name: "FinalizarTemporada",
          component: FinalizarTemporada,
        },
      ],
    },
    {
      path: "/ganaderia/mov-animal",
      name: "MovimientosGanaderos",
      redirect: {
        name: "MovimientoAnimal",
        params: { tipomovimientoslug: "ventas", codigo: "1" },
      },
      component: MovimientoAnimalBase,
      meta: {
        requiresEstablecimiento: true,
        requiresHasGanaderia: true,
        requiresHasInventarioInicial: true,
      },
      children: [
        {
          path: ":tipomovimientoslug/:codigo/:fechaDesde?/:fechaHasta?",
          props: true,
          name: "MovimientoAnimal",
          component: MovimientoAnimal,
        },
      ],
    },
    {
      path: "/ganaderia/resumen-mov-animal",
      name: "ResumenMovimientoGanaderos",
      component: MovimientoAnimalResumen,
      meta: {
        requiresEstablecimiento: true,
        requiresHasGanaderia: true,
        requiresHasInventarioInicial: true,
      },
    },
    {
      path: "/ganaderia/estadisticas",
      name: "EstadisticasGanaderia",
      component: EstadisticasGanaderia,
      meta: { requiresAdmin: true },
    },
    {
      path: "*",
      name: "NotFound",
      component: NotFound,
    },
    {
      path: "/privacy-policy",
      name: "Privacy",
      component: PrivacyPolicy,
    },
  ],
  // https://stackoverflow.com/a/67255615/15545971
  scrollBehavior(to, from, savedPosition) {
    // if (savedPosition) {
    //   return savedPosition
    // }

    if (to.hash) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve({ selector: to.hash, offset: { x: 0, y: 100 } });
        }, 400);
      });
    }

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 });
      }, 300);
    });
  },
});

router.beforeEach(async (to, from, next) => {
  // Is agricultor set?
  if (to.name === "Privacy") {
    next();
    return;
  }

  // Is logged in?
  if (!SessionService.isLoggedIn()) {
    location.href = `${LOGIN_URL}?nombre=${SITE_NAME}&redirect=${location.origin}${to.path}`;
    return;
  }

  await store.dispatch("session/restore", null, { root: true });

  // Is agricultor set?
  if (to.name !== "ElegirAgricultor") {
    if (!store.getters["agricultor/isAgricultorSet"]) {
      next({ name: "ElegirAgricultor" });
      return;
    }
  }

  // Has establecimientos?
  if (
    to.name !== "CrearEstablecimiento" &&
    to.matched.some((record) => record.meta.requiresEstablecimiento)
  ) {
    if (!store.getters["establecimientos/isEstablecimientoSet"]) {
      next({ name: "CrearEstablecimiento" });
      return;
    }
  }

  // Is ficha set?
  if (
    to.name !== "ElegirFicha" &&
    to.matched.some((record) => record.meta.requiresFicha)
  ) {
    if (!store.getters["fichas/isFichaAgricolaSet"]) {
      next({ name: "ElegirFicha", query: { next: to.path } });
      return;
    }
  }

  // Is view only for admin?
  if (to.matched.some((record) => record.meta.requiresAdmin)) {
    // Is user admin?
    if (!store.state.admin.esAdmin) {
      next({ name: "AgroHome" });
      return;
    }
  }

  if (to.matched.some((record) => record.meta.requiresHasAgro)) {
    // Routes only accesible if establecimiento has explotacion agro. If it hasnt redirect to Ganaderia.
    if (!store.getters["establecimientos/hasCategoriaAgricultura"]) {
      next({ name: "GanaderiaHome" });
      return;
    }
  }

  if (to.matched.some((record) => record.meta.requiresHasGanaderia)) {
    // Routes only accesible if establecimiento has explotacion ganadera. If it hasnt redirect to Agro.
    if (!store.getters["establecimientos/hasCategoriaGanaderia"]) {
      next({ name: "AgroHome" });
      return;
    }
  }

  if (to.matched.some((record) => record.meta.requiresCategoriaCheck)) {
    // Check for the '/' route. Checks last categoria and makes redirect to respective home
    if (store.getters["establecimientos/currentCategoria"] === 2) {
      next({ name: "GanaderiaHome" });
      return;
    } else {
      next({ name: "AgroHome" });
      return;
    }
  }

  if (
    to.name !== "FaltaInventario" &&
    to.matched.some((record) => record.meta.requiresHasInventarioInicial)
  ) {
    // Routes only accesible if inventario inicial was configured. If not, redirect to inventario inicial
    if (store.getters["lotes/getInventariosInicial"].length === 0) {
      next({ name: "FaltaInventario" });
      return;
    }
  }

  if (to.matched.some((record) => record.meta.requiresSuperficie)) {
    if (!store.getters["fichas/isSuperficieSet"]) {
      next({ name: "FaltaSuperficie" });
      return;
    }
  }

  next();
});

export default router;
